<template>
	<v-layout>
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-0">Your event's tagline &amp; Description...</p>
			<p class="add-event-step-sub-header mb-4">Try to keep it simple and fun!</p>
			<p class="add-event-step-secondary-header mb-0">Name</p>
			<div class="text-xs-center">
				<v-text-field
					v-model="title"
					color="link"
					placeholder="Enter your event title"
					class="d-inline-block mb-4"
					:disabled="titleDisabled"
					:title="titleDisabled ? 'You cannot edit titles for this event type' : ''"
					:style="{ width: '35%' }"
					hide-details
				></v-text-field>
				<div class="d-inline-block add-event-step-secondary-header mb-4" style="padding-top: 18px; height: 32px; vertical-align: top;">
					@ {{ locationName }}
				</div>
			</div>
			<p class="add-event-step-secondary-header mb-1">Tagline / Subtitle</p>
			<p class="add-event-step-sub-header mb-0">100 character max.</p>
			<v-text-field
				v-model="subtitle"
				color="link"
				placeholder="Enter your event subtitle / tagline"
				:error="subtitleError"
				:counter="100"
				:rules="[rules.subTitle]"
			></v-text-field>
			<p class="add-event-step-secondary-header mb-1">What attendees can expect (the event itinerary)</p>
			<p class="add-event-step-sub-header mb-0">
				Describe the event purpose and program, i.e. the planned schedule of activities and structure for the day. 
				Brevity and clarity go a long way!
			</p>
			<v-textarea
				v-model="description"
				placeholder="Enter your event description"
				color="link"
				:error="descriptionError"
				:rules="[rules.description]"
			></v-textarea>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card>
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="text-xs-center add-event-example-sub-header-light"><v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>Example {{exampleIndex+1}}/{{examples.length}}<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn></p>
					<p class="add-event-example-sub-header-light">Event Name</p>
					<p class="add-event-example-content">{{examples[exampleIndex].title}}</p>
					<p class="add-event-example-sub-header-light">Tagline / Subtitle</p>
					<p class="add-event-example-content">{{examples[exampleIndex].subtitle}}</p>
					<p class="add-event-example-sub-header-light">What to Expect</p>
					<p class="add-event-example-content mb-0" v-for="(line, index) in examples[exampleIndex].description" :key="index">{{line}}</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card class="add-event-tip-box" style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<div class="d-block text-xs-center" style="width: 100%;">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</div>
					<p style="display: block;" class="add-event-example-sub-header-light">Example {{exampleIndex+1}}/{{examples.length}}</p>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="height: 50vh;">
					<p class="add-event-example-sub-header-light">Event Name</p>
					<p class="add-event-example-content">{{examples[exampleIndex].title}}</p>
					<p class="add-event-example-sub-header-light">Tagline / Subtitle</p>
					<p class="add-event-example-content">{{examples[exampleIndex].subtitle}}</p>
					<p class="add-event-example-sub-header-light">What to Expect</p>
					<p class="add-event-example-content mb-0" v-for="(line, index) in examples[exampleIndex].description" :key="index">{{line}}</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
					<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div class="mb-3 add-event-step-info-link" @click="descriptionExampleDialog=true"><v-icon class="add-event-step-info-icon">fa-info-circle</v-icon> Examples</div> -->
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { replaceNewlines } from '~/store/util/util'
export default {
	data() {
		return {
			subtitleError: false,
			descriptionError: false,
			exampleIndex: 0,
			rules: {
				subTitle: value => {
					if (!value) {
						return true
					}
					if (value.length > 100) {
						this.subtitleError = true
						return '100 Character maximum'
					} else {
						this.subtitleError = false
						return true
					}
				},
				description: value => {
					if (!value) {
						return true
					}
					if (value.length < 200) {
						this.descriptionError = true
						return '200 Character minimum'
					} else if (value.length > 700) {
						this.descriptionError = true
						return '700 Character maximum'
					} else {
						this.descriptionError = false
						return true
					}
				}
			},
			examples: [
				{
					title: "WRKPRTY @ Sophia's Sanctuary",
					subtitle: 'Cowork with Sophia and friends in her Venice home.',
					description: [
						'Good people, beautiful work environment, a deep focus on flow.',
						'The plan: 9am - Check-in, Setup, & CoffeeTalk!',
						'9:15  - Warm-up (journal entry)',
						'9:30 - Worksprint #1',
						'10am - Group Break (Introductions)',
						'10:15 - Worksprint #2',
						'11am - Group Break (stretch and chat)',
						'11:15 - Worksprint #3',
						'Noon - Lunch & Siesta',
						'12:30 - Worksprint #4',
						'1:30 - Closing Celebration.',
						'Total head’s down time: 3.25 hrs',
						'Total social time: 1.25 hrs',
						'Total duration: 4.5 hours.'
					]
				},
				{
					title: 'WRKPRTY @ The Sumner House',
					subtitle:
						'Playful weekly coworking near Abbot Kinney, Venice Canals and Beach',
					description: [
						'This weekly WRKPRTY @ The Sumner House is a perfect way to make the most of your day!',
						'Our exact structure (work times & break times) vary slightly week-to-week, but generally you can count on our introduction circle taking place after the first work-sprint, around 10am.',
						'The activities we do vary week to week, but often include yoga or outdoor games that take advantage of our beautiful green grassy yard.'
					]
				},
				{
					title: 'WRKPRTY @ Beach House',
					subtitle:
						'First Friday afternoon coworking in the heart of Venice, CA',
					description: [
						'Our plan is to make the most of this Friday afternoon in the heart of Venice!',
						'12:30-1pm - Early check-in, setup, coffee & networking',
						'WORK SESSION',
						'1:45 - Group Break (Outdoor Stretch & Introductions)',
						'WORK SESSION',
						'2:50 - Group Break (Mingle time)',
						'WORK SESSION',
						'3:50 - Group Break (Quick game)',
						'WORK SESSION',
						'5pm - Closing Celebration',
						'Afterward, we encourage everyone to celebrate with us at the monthly First Friday event - just a few blocks away on Abbot Kinney Boulevard!'
					]
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (
			![this.title, this.description].includes(null) &&
			!this.descriptionError &&
			!this.subtitleError
		) {
			this.setAddEventValidStep(from.path)
			this.removeAddEventInvalidStep(from.path)
		} else {
			this.removeAddEventValidStep(from.path)
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'removeAddEventValidStep',
			'setAddEventValidStep',
			'setAddEventProp'
		]),
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		},
		newlines(value) {
			return replaceNewlines(value)
		}
	},
	computed: {
		...mapGetters(['getMyLocations', 'getAddEventProp']),
		locationName() {
			let location = this.getAddEventProp('location')
			if (location) {
				return location.name
			} else {
				return "Location Name"
			}
		},
		titleDisabled() {
			let type = this.getAddEventProp('wrkprtyType')
			return type === 'wrkprty'
		},
		title: {
			get() {
				return this.getAddEventProp('title')
			},
			set(val) {
				this.setAddEventProp({ prop: 'title', value: val })
			}
		},
		subtitle: {
			get() {
				return this.getAddEventProp('subtitle')
			},
			set(val) {
				this.setAddEventProp({ prop: 'subtitle', value: val })
			}
		},
		description: {
			get() {
				return this.getAddEventProp('description')
			},
			set(val) {
				this.setAddEventProp({ prop: 'description', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
